





































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { emptyText, loadingText } from '@/utils/constants';
import * as ITypes from '@/store/brand-audit/apply/types';
import Confirm from '@/components/dialog/Confirm.vue';
import TooltipIcon from '@/components/widget/TooltipIcon.vue';

const Apply = namespace('brandAudit/apply');

@Component({
  components: { Confirm, TooltipIcon },
})
export default class EnterpriseBrandAuthApply extends Vue {
  @Apply.Action('queryMyApplications') public queryApplications!: ITypes.IActions['queryMyApplications'];
  @Apply.State('applyList') public applyList!: ITypes.IBrandAuthApply;

  @Apply.Action('deleteApplication') public deleteApplication!: ITypes.IActions['deleteApplication'];

  @Apply.Mutation('setConfirm') public setConfirm!: ITypes.IActions['setConfirm'];
  @Apply.State('confirm') public confirm!: ITypes.IConfirm;

  @Prop() public visible!: boolean;

  public emptyText = emptyText;
  public loadingText = loadingText;
  public selection: ITypes.IBrandAuthApplyDto | null = null;
  public ossHost = process.env.VUE_APP_RES_OSS_URL as string;

  public headers = [
    { text: '品牌图片', value: 'thumb' },
    { text: '品牌编码', value: 'brandCode' },
    { text: '品牌名称', value: 'brandName' },
    { text: '操作', value: 'action', width: '60px' },
  ];

  public get confirmVisible() {
    const { type, visible } = this.confirm;
    return visible && (type === 'delete-application');
  }

  public set confirmVisible(visible: boolean) {
    if (!visible) {
      this.selection = null;
      this.setConfirm({ visible: false });
    }
  }

  public renderThumb(record: ITypes.IBrandAuthApplyDto) {
    return record.brandImg ? this.ossHost + record.brandImg : '';
  }

  public onDelete(record: ITypes.IBrandAuthApplyDto) {
    this.selection = record;
    const content = '是否确认取消申请？';
    this.setConfirm({ visible: true, type: 'delete-application', title: '取消申请', content });
  }

  public async onConfirm(ok: boolean) {
    const id = this.selection?.id;
    if (ok && id) {
      await this.deleteApplication({ id });
      this.selection = null;
      this.queryApplications();
    } else {
      this.confirmVisible = false;
    }
  }

  @Watch('visible', { immediate: true })
  public watchVisible(visible: boolean) {
    if (visible) {
      this.queryApplications();
    }
  }
}
